module.exports = "<span data-ng-message=required>*A control type is required</span> ";